<template>
  <div class="map_container">
    <!-- <div style="height: 100%; width: 100%; position: absolute; z-index: 9999999"
         v-if="isLoading">
      <a-spin size="large"
              style="top: 50%; right: 50%; position: absolute"
              title="加载中" />
    </div> -->
    <div id="scalebar"></div>
    <!-- 不明功能按钮 -->
    <div class="right-btn">
      <div class="right-item">
        <img src="@/assets/myImg/1/icon-ss.png" />
      </div>
      <div class="right-item" @click="showDrawer">
        <img src="@/assets/myImg/1/ns-icon-querynull.png" />
      </div>
      <div class="right-item" @click="changeZoom(true)">
        <img src="@/assets/myImg/1/icon-放大-normal.png" />
      </div>
      <div class="right-item" @click="changeZoom(false)">
        <img src="@/assets/myImg/1/icon-缩小-normal.png" />
      </div>
      <div class="right-item" @click="location">
        <img src="@/assets/myImg/1/定位.png" />
      </div>
    </div>
    <!-- 图例box使用第二个框包裹 -->
    <div class="right-btn" style="height: 7%; top: 35%">
      <div class="right-item" @click="showLengend = !showLengend">
        <img src="@/assets/myImg/1/图例.png" />
      </div>
    </div>

    <!-- 点击水管详情页 -->
    <div class="content-info" v-show="contentInfoShow">
      <!-- 标题 -->
      <div class="info-title">
        <span class="info-title--content">{{ costname }}详情</span>
        <img src="@/assets/myImg/1/icon-close.png" class="info-title--sufix" @click="closeOverLay()" />
      </div>
      <a-divider />

      <div id="info-popup-content">
        <div id="info-popup-content-page">
          <ul style="padding: 0px 10px">
            <!-- 下为冒号样式 -->
            <!-- 复制编码 -->
            <li v-for="(item, index) in newpopupObject1" :key="index" style="
                padding-top: 8px;
                font-family: MicrosoftYaHei;
                font-size: 14px;
                color: #000;
                font-weight: 400;
                width: 100%;
                display: inline-block;
                margin-left: 5vw;
              ">
              <!-- 下为数据名称样式 -->
              <span>{{ item[0] }}</span>：
              <span v-if="item[0] == '用户数量'">
                <a style="color: #000" @click="checkUserNum(item[2])">{{ item[1] }}</a>户
              </span>
              <span v-else-if="item[0] == '水表数量'">
                <a style="color: rgb(31 175 27)" @click="checkWaterNum(popupObject)">{{ item[1] }}</a>
              </span>

              <span v-else>{{ item[1] }} </span>
              <a @click="copyUrl(item[1])" style="color: rgba(27, 108, 232, 100)"> 复制</a>
            </li>
            <!-- 数据内容样式 -->
            <li v-for="(item, index) in newpopupObject2" :key="index" style="
                padding-top: 8px;
                font-family: MicrosoftYaHei;
                font-size: 14px;
                color: rgb(179, 186, 191);
                font-weight: 400;
                width: 50%;
                display: inline-block;
              ">
              <!-- 下为数据名称样式 -->
              <span>{{ item[0] }}</span>：
              <span v-if="item[0] == '用户数量'">
                <a style="color: #000" @click="checkUserNum(item[2])">{{ item[1] }}</a>户
              </span>

              <span v-else-if="item[0] == '水表数量'">
                <a style="color: rgb(31 175 27)" @click="checkWaterNum(popupObject)">{{ item[1] }}</a>
              </span>
              <!-- 数据内容样式 -->
              <span v-else>{{ item[1] }}</span>
            </li>
          </ul>
        </div>

        <button v-if="visibleTubeAnalysis" style="
            width: 90%;
            height: 2rem;
            color: #ffffff;
            border: 1px solid #0890f2;
            background-color: #0890f2;
            margin: 0px 0px 15px 12px;
          " @click="tubeAnalysis()">
          区域停水管控
        </button>
      </div>
    </div>

    <!-- 图例选择box -->
    <div id="lengendbox">
      <a-drawer placement="right" :closable="true" :visible="showLengend" :after-visible-change="afterVisibleChange"
        @close="closedrawer">
        <div class="lengend">
          <div class="layers">
            <div class="layer" v-for="(item, index) in filterLayerList" :key="item.id" @click="clickLabel(item, index)">
              <span class="layer-prefix">
                <template v-if="item.style">
                  <template v-if="item.style.styleType == 1">
                    <img :src="item.style.styleValue" class="prefix_icon" />
                  </template>
                  <template v-if="item.style.styleType == 2">
                    <div style="width: 20px; height: 20px; margin-left: 5px; margin-right: 5px">
                      <svg style="width: 100%; height: 100%">
                        <g fill="none" :stroke="item.style.styleValue | useStyle1">
                          <path :stroke-width="item.style.styleValue | useStyle2" d="M0 15 l65 0"
                            :stroke-dasharray="item.style.styleValue | useStyle3" />
                        </g>
                      </svg>
                      <!-- 不明svg 显示在页面上为一个小点 -->
                      <!--                                     <svg style="width: 100%; height: 50%" viewBox="-3 2 22 3">
                                        <g fill="none" :stroke="item.style.styleValue | useStyle1">
                                            <path
                                                d="M3,5 l1,-3 l1,3"
                                                :stroke-linejoin="item.style.styleValue | useStyle4"
                                            />
                                        </g>
                                            </svg>-->
                    </div>
                  </template>
                  <template v-if="item.style.styleType == 3">
                    <div style="height: 20px; width: 20px; margin-left: 5px; margin-right: 5px"
                      :style="item.style.styleValue | useStyle"></div>
                  </template>
                </template>
              </span>
              <span class="layer-content">
                <a-tooltip>
                  <template slot="title">{{ item.layerName }}</template>
                  {{ item.layerName.substring(0, 8) }}
                </a-tooltip>
              </span>
              <a-switch v-model="item.show" />
            </div>
          </div>
        </div>
      </a-drawer>
    </div>

    <NewTubeAnalysisModal ref="tubeAnalysisModal"></NewTubeAnalysisModal>
    <user-number-modal ref="userNumberModal"></user-number-modal>
    <water-number-modal ref="WaterNumberModal"></water-number-modal>
    <frame-data-modal ref="FrameDataModal"></frame-data-modal>
    <a-modal title="街景" :visible="showStreetView" width="80%" destroyOnClose @ok="closeStreetView"
      @cancel="closeStreetView" style="position: absolute; left: 18rem; z-index: 999; top: 3rem">
      <BaiDuMap ref="baidumap" :chooseCoordinates="chooseCoordinates"></BaiDuMap>
    </a-modal>

    <!-- 区域停水管控div -->
    <div>
      <div>
        <mobile-big-map-tube-drawer ref="tubeDrawer" :visible2="tubeVisible"
          @checkDetails="checkDetails"></mobile-big-map-tube-drawer>
      </div>
    </div>

    <div :id="domId" class="map" @drop="onDrop" @dragover="onDrop">
      <!-- 抽屉 -->
      <div>
        <big-map-drawer ref="Drawer" :visible="visible"></big-map-drawer>
      </div>

      <div id="popup" class="ol-popup" :style="{ opacity: 0 }" draggable="true" @dragstart="onDrag"
        @dragend="onDragEnd">
        <div class="popup_title">
          <span class="popup_title--prefix"></span>
          <span class="popup_title--content">你觉得这是什么详情</span>
          <img src="@/assets/myImg/1/icon-close.png" class="popup_title--sufix" id="popup-closer"
            @click="closeOverLay" />
        </div>
        <div id="popup-content">
          <div id="popup-content-page">
            <ul style="padding: 0px 10px">
              <li v-for="(item, index) in popupObject" :key="index"
                style="padding-top: 8px; font-family: MicrosoftYaHei; font-size: 13px; color: #ffffff; font-weight: 400">
                <span style="font-family: MicrosoftYaHei; font-size: 13px; color: #ffffff; font-weight: 400">{{
                  item[0]
                }}</span>:
                <span v-if="item[0] == '用户数量'">
                  <a @click="checkUserNum(item[2])">{{ item[1] }}</a>户
                </span>
                <span v-else>{{ item[1] }}</span>
              </li>
            </ul>
          </div>
          <button style="
              width: 90%;
              height: 2rem;
              color: #ffffff;
              border: 1px solid #0890f2;
              background-color: #0890f2;
              margin: 0px 0px 15px 12px;
            " @click="printpage()">
            打印
          </button>
          <button v-if="visibleTubeAnalysis" style="
              width: 90%;
              height: 2rem;
              color: #ffffff;
              border: 1px solid #0890f2;
              background-color: #0890f2;
              margin: 0px 0px 15px 12px;
            " @click="tubeAnalysis()">
            区域停水管控
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import storage from 'store'
import { LonLat } from '@/store/mutation-types'
import mapControl from './map-control'
import mapAlpha from './mapAlpha'
import Map from 'ol/Map'
import TileLayer from 'ol/layer/Tile'
import View from 'ol/View'
import XYZ from 'ol/source/XYZ'
import * as olProj from 'ol/proj'
import { saveAs } from 'file-saver'
import ImageWMS from 'ol/source/ImageWMS'
import ImageLayer from 'ol/layer/Image'
import { getLegendDetailByCode, getGeophysicalPoint, getInfluencePoint } from '@/api/manage'
import LineString from 'ol/geom/LineString'
import { getUUID } from '@/utils/util'
import Overlay from 'ol/Overlay'
import VectorSource from 'ol/source/Vector'
import VectorLayer from 'ol/layer/Vector'
import Feature from 'ol/Feature'
import Fill from 'ol/style/Fill'
import Stroke from 'ol/style/Stroke'
import Point from 'ol/geom/Point'
import Polygon from 'ol/geom/Polygon'
import Style from 'ol/style/Style'
import Circle from 'ol/style/Circle'
import Icon from 'ol/style/Icon'
import ScaleLine from 'ol/control/ScaleLine'
import { unByKey } from 'ol/Observable'
import iconQuery from '@/assets/myImg/1/ns-icon-query.svg?inline'
import iconQueryLight from '@/assets/myImg/1/ns-icon-query-light.svg?inline'
import BigMapDrawer from './NewBigMapDrawer'
import { gcj02tobd09, wgs84togcj02 } from './zuobiaozhuanhuan'
import mapDiaphaneity from './mapDiaphaneity'
import BaiDuMap from './BaiDuMap.vue'
import * as turf from '@turf/turf'
import NewTubeAnalysisModal from './NewTubeAnalysisModal'

import UserNumberModal from './UserNumberModal'
import WaterNumberModal from './WaterNumberModal'
import printJs from 'print-js'
// import BigMapTubeDrawer from './NewBigMapTubeDrawer'//原区域停水管控
import MobileBigMapTubeDrawer from './MobileBigMapTubeDrawer' // 移动区域停水管控
import FrameDataModal from './NewFrameDataModal'
import { defaults } from 'ol/interaction'
let map = null
let lightFeature = null
let x = 0
let y = 0
// let map = null
export default {
  name: 'BigMap',
  components: {
    mapAlpha,
    iconQuery,
    iconQueryLight,
    BigMapDrawer,
    BaiDuMap,
    mapDiaphaneity,
    mapControl,
    NewTubeAnalysisModal,
    UserNumberModal,
    // BigMapTubeDrawer,
    MobileBigMapTubeDrawer,
    FrameDataModal,
    WaterNumberModal
  },
  watch: {
    tubeVisible: {
      handler (value) {
        if (value === false) {
          this.removeLayerByName('停水管控')
          this.removeLayerByName('停水管控2')
        }
      },
      deep: true
    },
    isActive: {
      handler (value) {
        if (value !== '框选打印') {
          this.$refs.dragBox.clearMap()
        }
      },
      deep: true
    }
  },
  data () {
    return {
      contentInfoShow: false,
      isActive: '查询',
      showOw: true,
      showAll: false,
      visible: false,
      tubeVisible: false,
      domId: getUUID(),
      openyxcxTable: false,
      openQueryTable: false,
      opensscxTable: false,
      opendlcsTable: false,
      diameter: '',
      material: '',
      isLoading: false,
      sscxInputData: null,
      radioGroupValue: 1,
      cqlString: '',
      layerList: [],
      lightFeature: null,
      showLengend: false, // 显示图例
      popupObject: [],
      newpopupObject1: [], // 管道详情开始结束编码
      newpopupObject2: [], // 管道详情其他数据
      costname: '', // 详情name
      streetViewButton: false,
      showStreetView: false,
      chooseCoordinates: [],
      clickTypeList: [],
      visibleTubeAnalysis: false, // 爆管分析
      layer_numberId: ''
    }
  },
  filters: {
    useStyle: (value) => {
      const arr = value.split(';')
      const arrs = []
      for (let i = 0; i < arr.length; i++) {
        arrs.push(arr[i].split(':')[1])
      }
      return `background:${arrs[0]};border:${arrs[1]} ${arrs[3]}px solid; opacity:${arrs[2]}; width:20px`
    },
    useStyle1: (value) => {
      const arr = value.split(';')
      const arrs = []
      for (let i = 0; i < arr.length; i++) {
        arrs.push(arr[i].split(':')[1])
      }
      return `${arrs[1]}`
    },
    useStyle2: (value) => {
      const arr = value.split(';')
      const arrs = []
      for (let i = 0; i < arr.length; i++) {
        arrs.push(arr[i].split(':')[1])
      }
      return `${arrs[0]}`
    },
    useStyle3: (value) => {
      const arr = value.split(';')
      const arrs = []
      for (let i = 0; i < arr.length; i++) {
        arrs.push(arr[i].split(':')[1])
      }
      return `${arrs[2]}`
    },
    useStyle4: (value) => {
      const arr = value.split(';')
      const arrs = []
      for (let i = 0; i < arr.length; i++) {
        arrs.push(arr[i].split(':')[1])
      }
      return `${arrs[3]}`
    }
  },
  mounted () {
    this.initMap()
    this.redLine()
  },
  computed: {
    filterLayerList: function () {
      return this.layerList.filter(function (item) {
        return item.showLegend
      })
    }
  },
  props: {
    code: {
      type: String,
      default: ''
    }
  },
  methods: {
    onDragEnd (e) {
      e.dataTransfer.dropEffect = 'copy'
      const tx = e.clientX - x + 'px'
      const ty = e.clientY - y + 'px'
      // e.srcElement.offsetParent.style.transform=e.srcElement.offsetParent.style.transform+ ` translate(${tx}, ${ty})`;
      document.getElementById('popup').style.transform =
        document.getElementById('popup').style.transform + ` translate(${tx}, ${ty})`
      x = 0
      y = 0
      e.preventDefault()
    },
    onDrop (e) {
      e.preventDefault()
    },
    onDrag (e) {
      x = e.clientX
      y = e.clientY
      e.dataTransfer.effectAllowed = 'copyMove'
    },
    // 查看用户数量详细信息
    checkUserNum (params) {
      this.$refs.userNumberModal.edit(params)
    },
    checkWaterNum (params) {
      const arr = params.find((item) => {
        return item[0] == '分类编码'
      })
      this.$refs.WaterNumberModal.edit(arr[1])
    },
    // 查看爆管详情
    checkDetails (id) {
      console.log(id)
      this.$refs.tubeAnalysisModal.edit(id)
      console.log(this.$refs.tubeAnalysisModal)
    },
    setResolutions (resolutions) {
      map.resolutions = resolutions
    },
    addLayer (layer) {
      map.addLayer(layer)
    },
    getBigMap () {
      return map
    },
    setMaxZoom (zoom) {
      map.getView().setMaxZoom(zoom)
    },
    initMap () {
      const gcj02Extent = [-20037508.342789244, -20037508.342789244, 20037508.342789244, 20037508.342789244]
      const gcjMecator = new olProj.Projection({
        code: 'GCJ-02',
        extent: gcj02Extent,
        units: 'm'
      })
      olProj.addProjection(gcjMecator)
      olProj.addCoordinateTransforms('EPSG:4326', gcjMecator, window.projzh.ll2gmerc, window.projzh.gmerc2ll)
      olProj.addCoordinateTransforms('EPSG:3857', gcjMecator, window.projzh.smerc2gmerc, window.projzh.gmerc2smerc)
      map = new Map({
        view: new View({
          center: [Number(storage.get(LonLat)[0]), Number(storage.get(LonLat)[1])], // 中心点, 填的是经纬度
          projection: 'EPSG:4326', // EPSG:4326格式的经纬度
          zoom: 13.5, // 地图默认缩放级别
          maxZoom: 19, // 地图最大缩放级别
          minZoom: 1 // 地图最小缩放级别
        }),
        controls: defaults({
          zoom: false,
          rotate: false,
          attribution: false
        }),
        interactions: defaults({
          doubleClickZoom: false // 取消双击放大功能交互
        }),
        target: this.domId // 地图容器id
      })
      const road_layer = new TileLayer({
        name: '底图',
        title: '高德地图',
        source: new XYZ({
          projection: gcjMecator,
          crossOrigin: 'anonymous',
          url: 'http://wprd0{1-4}.is.autonavi.com/appmaptile?lang=zh_cn&size=1&style=7&x={x}&y={y}&z={z}'
        })
      })
      map.on('click', function (e) {
        console.log('click=====MobileBigMap')
      })
      map.addLayer(road_layer)
      this.location()
      this.getLayers()
    },
    showDrawer () {
      this.isActive = '查询'
      this.tubeVisible = false
      this.visible = !this.visible
      this.$refs.Drawer.show()
    },
    clearKuang () {
      this.$refs.mapControls.clearMap()
    },
    /*         showTubeDrawer() {
                    console.log('停水管控')
                    this.isActive = '停水管控'
                    this.visible = false
                    this.tubeVisible = !this.tubeVisible
                    if (this.tubeVisible) {
                        this.removeLayerByName('停水分析')
                        // ASD
                        // this.tubeAnalysis()
                        this.$refs.tubeDrawer.checkColor()
                    } else {
                        this.redSourceLength = false
                        this.removeLayerByName('水表')
                        this.removeLayerByName('阀门')
                        this.closeOverLay()
                        this.redSource.clear()
                        this.removeLayerByName('停水管控')
                        this.removeLayerByName('停水管控2')
                    }
                }, */
    onClose () {
      this.visible = false
    },
    openStreetView () {
      // this.chooseCoordinates
      this.showStreetView = true
    },
    closeStreetView () {
      this.showStreetView = false
    },
    clickLabel (item, index) {
      var thisName = item.id
      var newid
      const allLayers = map.getLayers()
      if (item.layerName === '物探点') {
        this.showAll = !this.showAll
        var listName = [
          '物探点',
          '弯头',
          '三通',
          '阀门',
          '水表',
          '消防栓',
          '排水阀',
          '排气阀',
          '分区流量计',
          '加压泵站',
          '预留口',
          '一般管线点',
          '变径',
          '四通',
          '变材',
          '阀门井',
          '水表井'
        ]
        listName.forEach((items2) => {
          this.layerList.forEach((items3) => {
            if (items2 === items3.layerName) {
              newid = items3.id
              const filterIndex = this.layerList.findIndex((layer) => {
                return layer.id == newid
              })
              this.$set(this.layerList, filterIndex, { ...items3, show: this.showAll })
            }
          })
          //
          allLayers.array_.forEach((items) => {
            if (newid === items.values_.name) {
              //  console.log(items.values_.visible)
              //  items.values_.visible=!items.values_.visible
              items.setVisible(this.showAll)
              // var divs = document.getElementsByClassName('layer-content')[index]
            }
          })
        })
      } else {
        allLayers.array_.forEach((items) => {
          if (thisName === items.values_.name) {
            //  console.log(items.values_.visible)
            //  items.values_.visible=!items.values_.visible
            items.setVisible(!items.values_.visible)
            // var divs = document.getElementsByClassName('layer-content')[index]
            const filterIndex = this.layerList.findIndex((layer) => {
              return layer.id == thisName
            })
            console.log(items.values_.visible)
            this.$set(this.layerList, filterIndex, { ...item, show: items.values_.visible })

            //  if (!items.values_.visible) {

            //  } else {
            //   divs.style.color = 'rgba(0,255,255,0.5)'
            //  }
          }
        })
      }
    },
    getLayers () {
      getLegendDetailByCode(this.code)
        .then(({ data }) => {
          const { layerList } = data
          layerList.forEach(layer => { if (layer.showFilterCondition) { layer.showFilterCondition = layer.showFilterCondition.replace(/is_deleted\s*=\s*0/g, 'is_deleted = false') } })
          if (layerList && layerList.length > 0) {
            this.layerList = layerList.map((v) => ({ ...v, show: !!v.defaultLoad }))
            console.log(this.layerList)
            layerList.map((layer) => {
              if (layer.style.styleType === 1) {
                console.log(layer.showLegend)
                console.log('layerlayer', layer)
                // if (!layer.showLegend) {
                if (layer.layerName !== '物探点') {
                  this.wmsLayers(layer, layer.showFilterCondition, layer.defaultLoad)
                }
                // } else {
                //   this.wmsLayers(layer, layer.showFilterCondition, false)
                // }
              } else {
                if (layer.layerName !== '物探点') {
                  // 是否默认显示从写死为true改为defaultLoad
                  this.wmsLayers(layer, layer.showFilterCondition, layer.defaultLoad)
                }
              }
            })
          }
        })
        .catch((e) => {
          console.log(e)
        })
    },
    removeLayerByName (name) {
      const allLayers = map.getLayers()
      var list = allLayers.array_
      console.log('allLayers', allLayers)
      console.log('list', list)
      for (let index = 0; index < list.length; index++) {
        const layer = list[index]
        if (layer.values_.name === name) {
          console.log('删除涂层', layer)
          map.removeLayer(layer)
          // index--
        }
      }
    },
    // 点击显示的红色线
    redLine () {
      // 红色线
      this.redSource = new VectorSource()
      this.redVector = new VectorLayer({
        source: this.redSource,
        zIndex: 9999999,
        style: new Style({
          fill: new Fill({
            color: '#FF0000'
          }),
          stroke: new Stroke({
            width: 3,
            color: [255, 0, 0, 1]
          })
        })
      })
      map.addLayer(this.redVector)
    },
    queryData (type) {
      this.cqlString = ''
      if (type === '设施查询') {
        if (this.radioGroupValue === 1) {
          // this.cqlString = '&CQL_FILTER=%20%22geophysical_point_number%22LIKE%27' + this.sscxInputData + '%27'
          this.cqlString = '"geophysical_point_number"=\'' + this.sscxInputData + "'"
        }
        if (this.radioGroupValue === 2) {
          // this.cqlString = '&CQL_FILTER=%20%22feature_point%22LIKE%27' + this.sscxInputData + '%27'
          this.cqlString = '"feature_point"=\'' + this.sscxInputData + "'"
        }
        if (this.sscxInputData === '水表' || this.sscxInputData === '阀门井') {
          this.wmsLayers('smart_water:pipe_network', this.cqlString)
        } else {
          this.wmsLayers('smart_water:pipe_network', this.cqlString)
        }
      }
      if (type === '条件查询') {
        // diameter  material
        if (this.diameter.length > 0 && this.material.length > 0) {
          // this.cqlString = '&CQL_FILTER=%20%22pipeline_material%22LIKE%27' + this.material + '%27and%20%22pipe_diameter_size%22=' + Number(this.diameter)
          this.cqlString =
            '"pipeline_material"=\'' + this.material + '\'and"pipe_diameter_size"=' + Number(this.diameter)
        } else if (this.material.length > 0) {
          // this.cqlString = '&CQL_FILTER=%20%22pipeline_material%22LIKE%27' + this.material + '%27'
          this.cqlString = '"pipeline_material"=\'' + this.material + "'"
        } else if (this.diameter.length > 0) {
          this.cqlString = '"pipe_diameter_size"=' + Number(this.diameter)
          // this.cqlString = '&CQL_FILTER=%22pipe_diameter_size%22=' + Number(this.diameter)
        }
        this.wmsLayers('smart_water:pipe_network', this.cqlString)
      }
    },
    opensscxTables () {
      this.opensscxTable = !this.opensscxTable
      if (this.opensscxTable) {
        this.opendlcsTable = false
        this.openyxcxTable = false
        this.openQueryTable = false
      }
    },
    opendlcsTables () {
      this.opendlcsTable = !this.opendlcsTable
      if (this.opendlcsTable) {
        this.opensscxTable = false
        this.openyxcxTable = false
        this.openQueryTable = false
      }
    },
    openyxcxTables () {
      this.openyxcxTable = !this.openyxcxTable
      if (this.openyxcxTable) {
        this.openQueryTable = false
        this.opensscxTable = false
        this.opendlcsTable = false
      }
    },
    openQuery () {
      this.openQueryTable = !this.openQueryTable
      if (this.openQueryTable) {
        this.openyxcxTable = false
        this.opensscxTable = false
        this.opendlcsTable = false
      }
    },
    simplePoint (data, name, src, properties = null) {
      console.log('MobileBigMap=====simplePoint=====')
      const vectorSource = new VectorSource()
      // data.forEach(item => {
      // })
      var i = 0
      for (i; i < data.length; i++) {
        const point = new Point(data[i])
        map.getView().setCenter(data[i])
        const feature = new Feature(point)
        if (properties !== null) {
          feature.properties = properties[i]
        }
        vectorSource.addFeature(feature)
      }
      console.log('vectorSource', vectorSource)
      var vectorLayer = new VectorLayer({ source: vectorSource, name: name, zIndex: 999999 })
      // 设置feature的样式
      vectorLayer.setStyle(
        new Style({
          image: new Icon({
            crossOrigin: 'anonymous',
            src: src || require('@/assets/myImg/1/icon-阀门.png'),
            scale: 0.5
          })
        })
      )
      map.getView().setZoom(16)
      map.addLayer(vectorLayer)
    },
    // 受影响得线
    influenceLine (data) {
      // 红色线
      const params = {
        classNos: data
      }
      getInfluencePoint(params)
        .then(({ data }) => {
          //
          console.log('受影响得线', data)
        })
        .catch(() => { })
    },
    wmsLayers (layer, cql = '', isVisible = true) {
      this.removeLayerByName(layer.id)
      this.closeOverLay()
      console.log('进来', layer)
      console.log('条件', cql)
      lightFeature.getGeometry().setCoordinates([0, 0])
      const params = { LAYERS: layer.dataSource, FORMAT: 'image/png' }
      if (cql) params.CQL_FILTER = cql
      const wmsSource = new ImageWMS({
        crossOrigin: 'anonymous',
        params,
        serverType: 'geoserver',
        url: `/api/geoserver/${layer.workspace}/wms`
      })
      const wmsLayer = new ImageLayer({
        name: layer.id,
        crossOrigin: 'anonymous',
        projection: 'EPSG:4490',
        source: wmsSource,
        zIndex: layer.layerShowSort || 99
      })
      wmsLayer.setVisible(isVisible)
      map.addLayer(wmsLayer)
      var that = this
      if (layer.dataSource === 'smart_water:gis_pipe_line') {
        wmsSource.on('imageloadstart', function (event) {
          that.isLoading = true
          // ----打开Loading
        })
        // postrender
        wmsSource.on('imageloadend', function (event) {
          console.log('渲染完成', layer)
          console.log('条件', cql)
          that.isLoading = false
          // // ----关闭Loading
        })
      }
      if (
        layer.dataSource !== 'smart_water:water_supply_range' &&
        layer.dataSource !== 'smart_water:water_factory_area'
      ) {
        this.clickWMS(wmsSource, layer, wmsLayer)
      }
    },
    queryWmsLayers (workspace, layerName, cql) {
      this.removeLayerByName('condition_query_wms_layer')
      this.closeOverLay()
      lightFeature.getGeometry().setCoordinates([0, 0])
      const params = { LAYERS: layerName, FORMAT: 'image/png' }
      if (cql) params.CQL_FILTER = cql
      // if (cql.indexOf('class_no') != -1) {
      //   params.STYLES = 'point'
      // }
      const wmsSource = new ImageWMS({
        crossOrigin: 'anonymous',
        params,
        serverType: 'geoserver',
        url: `/api/geoserver/${workspace}/wms`
      })
      const wmsLayer = new ImageLayer({
        name: 'condition_query_wms_layer',
        crossOrigin: 'anonymous',
        projection: 'EPSG:4490',
        source: wmsSource,
        zIndex: 99999
      })
      map.addLayer(wmsLayer)

      // 添加可点击事件
      this.clickWMS(wmsSource, { id: 'condition_query_wms_layer' }, wmsLayer)
      // this.clickWMS(wmsSource, { 'id':'search_gis_pipe_line' }, wmsLayer)
      // this.clickWMS(wmsSource, layer)
    },
    // WMS点击事件
    clickWMS (wmsSource, layer, wmsLayer) {
      // if (Object.keys(this.clickTypeList).indexOf(layer.id) === -1){
      unByKey(this.clickTypeList[layer.id])
      console.log('this.clickTypeList', this.clickTypeList)
      const that = this
      this.clickTypeList[layer.id] = map.on(
        'click',
        function (e) {
          const url = wmsSource.getFeatureInfoUrl(e.coordinate, map.getView().getResolution(), 'EPSG:4326', {
            INFO_FORMAT: 'application/json'
          })
          // 判断是否有要素，一般wms返回的是false没有要素，所以wms的功能代码在else里
          if (map.hasFeatureAtPixel(e.coordinate)) {
            if (url) {
              fetch(url)
                .then((response) => {
                  return response.json()
                })
                .then((data) => { })
            }
          } else {
            if (url) {
              fetch(url)
                .then((response) => {
                  return response.json()
                })
                .then((data) => {
                  if (data.features.length != 0) {
                    if (wmsLayer.values_.visible) {
                      const layer_id = data.features[0].id.split('.')[0]
                      this.layer_numberId = data.features[0].id.split('.')[1]
                      that.addOverLay(e.coordinate, layer_id, data.features[0].properties)
                      if (layer_id === 'gis_pipe_network' || layer_id === 'gis_pipe_line') {
                        that.streetViewButton = true
                        // that.chooseCoordinates = wgs84togcj02(e.coordinate[0], e.coordinate[1]);
                        const wgs84togcj02Data = wgs84togcj02(e.coordinate[0], e.coordinate[1])
                        that.chooseCoordinates = gcj02tobd09(wgs84togcj02Data[0], wgs84togcj02Data[1])
                        lightFeature.getGeometry().setCoordinates(data.features[0].geometry.coordinates)
                      } else if (layer_id === 'zone_metering') {
                        var leval = data.features[0].properties.level
                        var downCode = data.features[0].id
                        // alert(leval)
                        if (leval <= 2) {
                          leval += 1
                          // level = 1
                          var cqls = 'is_deleted = false and pid = ' + String(downCode)
                          that.wmsLayers(layer, cqls)
                        }
                        // that.wmsLayers()
                      }
                    }
                  }
                })
            }
          }
        }.bind(this)
      )
      // }
    },
    // 百度坐标转高德（传入经度、纬度）
    bd_decrypt (bd_lng, bd_lat) {
      var X_PI = (Math.PI * 3000.0) / 180.0
      var x = bd_lng - 0.0065
      var y = bd_lat - 0.006
      var z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * X_PI)
      var theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * X_PI)
      var gg_lng = z * Math.cos(theta)
      var gg_lat = z * Math.sin(theta)
      return [gg_lng, gg_lat]
    },
    // 爆管，区域停水分析点击方法
    tubeAnalysis () {
      this.removeLayerByName('停水分析')
      this.removeLayerByName('停水管控2')
      this.$nextTick(() => {
        this.visible = false
        this.contentInfoShow = false
        // this.tubeVisible = true
        this.tubeVisible = !this.tubeVisible
        this.$refs.tubeDrawer.check(this.layer_numberId)
        this.$refs.tubeDrawer.checkColor()
        console.log(1234)
      })
      this.redSourceLength = true
      this.redSource.getFeatures().forEach((item, index) => {
        if (this.redSource.getFeatures().length > 1) {
          if (index < 1) {
            this.redSource.removeFeature(item)
          }
        }
      })
      this.popupObject.forEach((item) => {
        if (item[0] === '物探点号' || item[0] === '物探起点点号') {
          getGeophysicalPoint(item[1]).then((data) => {
            const xList = []
            const yList = []
            if (data.data.length > 1) {
              data.data.forEach((items) => {
                xList.push(Number(items[0]))
                yList.push(Number(items[1]))
              })
              const minX = Math.min(...xList)
              const maxX = Math.max(...xList)
              const minY = Math.min(...yList)
              const maxY = Math.max(...yList)
              var PolygonGeom = [
                [
                  [minX, maxY],
                  [maxX, maxY],
                  [maxX, minY],
                  [minX, minY],
                  [minX, maxY]
                ]
              ]
              this.simplePolygon(PolygonGeom, '停水分析')
            }
          })
        }
      })
    },
    // 面数据绘制
    simplePolygon (data, name) {
      //
      const vectorSource = new VectorSource()
      const polygon = new Polygon(data)
      const feature = new Feature(polygon)
      vectorSource.addFeature(feature)
      console.log('vectorSource', vectorSource)
      var vectorLayer = new VectorLayer({ source: vectorSource, name: name, zIndex: 999999 })
      var polygonSize = feature.getGeometry()
      map.getView().fit(polygonSize)
      // 设置feature的样式
      vectorLayer.setStyle(
        new Style({
          fill: new Fill({
            // 矢量图层填充颜色，以及透明度
            color: 'rgba(0, 255, 255, 0.6)'
          })
        })
      )
      // map.getView().setZoom(16)
      map.addLayer(vectorLayer)
    },
    printpage () {
      const style = '@page {margin:0 0mm};'
      printJs({ printable: 'info-popup-content-page', type: 'html', scanStyles: true, style: style })
    },
    // 级别加减
    changeZoom (type) {
      if (type) {
        map.getView().setZoom(map.getView().getZoom() + 1)
      } else {
        map.getView().setZoom(map.getView().getZoom() - 1)
      }
    },
    // 爆管分析跳转
    jumpFather (record) {
      console.log(record)
      map.getView().setCenter([record.coordinatePointX, record.coordinatePointY])
      map.getView().setZoom(13)
    },
    // 定位
    location () {
      this.isActive = '定位'
      map.getView().setCenter(storage.get(LonLat))
      map.getView().setZoom(13.4)
      // map.addLayer(road_layer)
      const lightPoint = new Point([0, 0])
      lightFeature = new Feature({
        geometry: lightPoint // geometry: new ol.geom.Point([0, 0]),
      })
      const vectorSource = new VectorSource({
        features: [lightFeature]
      })
      const vectorLayer = new VectorLayer({
        name: 'pointLight',
        zIndex: 99999,
        source: vectorSource,
        style: new Style({
          image: new Circle({
            radius: 6,
            fill: new Fill({
              color: '#00FFFF',
              opacity: 0.2
            })
          })
        })
      })
      map.addLayer(vectorLayer)
    },
    closeOverLay2 () {
      lightFeature.getGeometry().setCoordinates([0, 0])
      this.popupObject = []
      this.newpopupObject1 = []
      this.newpopupObject2 = []
      this.costname = ''
      this.coordinates = []
      const closer = document.getElementById('popup-closer')
      if (this.popup) {
        this.popup.setPosition(undefined)
      }

      // this.showOw = false
      closer.blur()
    },
    closeOverLay () {
      this.closeOverLay2()
      this.contentInfoShow = false
      // this.contentInfoShow = !this.contentInfoShow
      // this.redSource.clear()
      this.removeLayerByName('停水管控')
      this.removeLayerByName('停水管控2')
    },
    /**
     * 点击出现详情
     */
    addOverLay (coordinates, id, object) {
      // 去掉红色线
      // 属性
      this.contentInfoShow = true
      // 判断是不是线
      id == 'gis_pipe_line' ? (this.visibleTubeAnalysis = true) : (this.visibleTubeAnalysis = false)
      console.log(id, object)
      // content.innerHTML = '<p>图层属性</p><code>' + object + '</code>' // 这个课扩展
      if (id == 'pipe_network') {
        const {
          feature_point,
          buried_depth,
          ground_elevation,
          geophysical_point_number,
          pipe_network_number,
          connection_point_number,
          pipeline_material,
          pipe_diameter_size,
          coordinate_point_x,
          coordinate_point_y,
          factory,
          well_lid_texture,
          well_depth,
          valve_type, // 阀门类型
          status, // 状态0 良好 ,1 密封性能差 ,2 损坏 ,3 联通阀门关闭。
          install_time, // 安装时间
          unit_num, // 机组数量
          unit_power, // 机组功率
          last_maintenance_time, // 上次保养时间
          subordinate_way, // 所属道路
          forcing_pump_status, // 加压泵类型
          zone_id
        } = object
        const statusName = status == 0 ? '良好' : status == 1 ? '密封性能差' : status == 2 ? '损坏' : '联通阀门关闭'
        const name = object.feature_point
        this.costname = object.feature_point
        console.log(name)
        if (name == '水表') {
          const params = {
            geophysicalPointNumber: geophysical_point_number,
            zoneId: zone_id
          }
          this.$http
            .get('/pipe-network/user_water_meters/page', { params })
            .then((res) => {
              const total = res.data.total

              // 水表卡片属性
              this.popupObject = [
                ['特征点附属物名称', feature_point],
                ['物探点号', geophysical_point_number],
                // ['厂家', factory],
                // ['口径', pipe_diameter_size],
                // ['用户编号', ''],
                ['坐标X', coordinate_point_x],
                ['坐标Y', coordinate_point_y],
                ['地面高程m', ground_elevation],
                ['用户数量', total, params],
                ['安装时间', install_time]
              ]
              this.costname = object.feature_point
              this.newpopupObject1 = [
                ['特征点附属物名称', feature_point],
                ['物探点号', geophysical_point_number],
                // ['厂家', factory],
                // ['口径', pipe_diameter_size],
                // ['用户编号', ''],
                ['坐标X', coordinate_point_x],
                ['坐标Y', coordinate_point_y],
                ['地面高程m', ground_elevation],
                ['用户数量', total, params],
                ['安装时间', install_time]
              ]
            })
            .catch(() => { })
        } else if (name == '水表井' || name == '阀门井') {
          this.popupObject = [
            ['特征点附属物名称', feature_point],
            ['物探点号', geophysical_point_number],
            ['编号', pipe_network_number],
            ['井盖材质', well_lid_texture],
            ['井深', well_depth],
            ['坐标X', coordinate_point_x],
            ['坐标Y', coordinate_point_y],
            ['地面高程m', ground_elevation],
            ['安装时间', install_time]
          ]
          this.costname = object.feature_point
          this.newpopupObject1 = [
            ['特征点附属物名称', feature_point],
            ['物探点号', geophysical_point_number],
            ['编号', pipe_network_number],
            ['井盖材质', well_lid_texture],
            ['井深', well_depth],
            ['坐标X', coordinate_point_x],
            ['坐标Y', coordinate_point_y],
            ['地面高程m', ground_elevation],
            ['安装时间', install_time]
          ]
        } else if (name == '排水阀' || name == '排气阀') {
          this.popupObject = [
            ['特征点附属物名称', feature_point],
            ['物探点号', geophysical_point_number],
            ['阀门类型', valve_type],
            ['状态', statusName],
            ['口径', 'DN' + pipe_diameter_size],
            ['厂家', factory],
            ['坐标X', coordinate_point_x],
            ['坐标Y', coordinate_point_y],
            ['地面高程m', ground_elevation],
            ['安装时间', install_time]
          ]
          this.costname = object.feature_point
          this.newpopupObject1 = [
            ['特征点附属物名称', feature_point],
            ['物探点号', geophysical_point_number],
            ['阀门类型', valve_type],
            ['状态', statusName],
            ['口径', 'DN' + pipe_diameter_size],
            ['厂家', factory],
            ['坐标X', coordinate_point_x],
            ['坐标Y', coordinate_point_y],
            ['地面高程m', ground_elevation],
            ['安装时间', install_time]
          ]
        } else if (name == '加压泵站') {
          this.popupObject = [
            ['特征点附属物名称', feature_point],
            ['物探点号', geophysical_point_number],
            // ['建设时间', install_time],
            ['机组数量', unit_num],
            ['机组功率', unit_power],
            ['加压泵类型', forcing_pump_status],
            ['厂家', factory],
            ['坐标X', coordinate_point_x],
            ['坐标Y', coordinate_point_y],
            ['地面高程m', ground_elevation],
            ['安装时间', install_time]
          ]
          this.costname = object.feature_point
          this.newpopupObject1 = [
            ['特征点附属物名称', feature_point],
            ['物探点号', geophysical_point_number],
            // ['建设时间', install_time],
            ['机组数量', unit_num],
            ['机组功率', unit_power],
            ['加压泵类型', forcing_pump_status],
            ['厂家', factory],
            ['坐标X', coordinate_point_x],
            ['坐标Y', coordinate_point_y],
            ['地面高程m', ground_elevation],
            ['安装时间', install_time]
          ]
        } else if (name == '预留口') {
          this.popupObject = [
            ['特征点附属物名称', feature_point],
            ['物探点号', geophysical_point_number],
            ['口径', 'DN' + pipe_diameter_size],
            ['坐标X', coordinate_point_x],
            ['坐标Y', coordinate_point_y],
            ['地面高程m', ground_elevation],
            ['安装时间', install_time]
          ]
          this.costname = object.feature_point
          this.newpopupObject1 = [
            ['特征点附属物名称', feature_point],
            ['物探点号', geophysical_point_number],
            ['口径', 'DN' + pipe_diameter_size],
            ['坐标X', coordinate_point_x],
            ['坐标Y', coordinate_point_y],
            ['地面高程m', ground_elevation],
            ['安装时间', install_time]
          ]
        } else if (name == '阀门') {
          this.popupObject = [
            ['特征点附属物名称', feature_point],
            ['物探点号', geophysical_point_number],
            ['编号', pipe_network_number],
            ['阀门类型', valve_type],
            ['口径', 'DN' + pipe_diameter_size],
            ['厂家', factory],
            ['状态', statusName],
            ['上次保养时间', last_maintenance_time],
            ['坐标X', coordinate_point_x],
            ['坐标Y', coordinate_point_y],
            ['地面高程m', ground_elevation],
            ['安装时间', install_time]
          ]
          this.costname = object.feature_point
          this.newpopupObject1 = [
            ['特征点附属物名称', feature_point],
            ['物探点号', geophysical_point_number],
            ['编号', pipe_network_number],
            ['阀门类型', valve_type],
            ['口径', 'DN' + pipe_diameter_size],
            ['厂家', factory],
            ['状态', statusName],
            ['上次保养时间', last_maintenance_time],
            ['坐标X', coordinate_point_x],
            ['坐标Y', coordinate_point_y],
            ['地面高程m', ground_elevation],
            ['安装时间', install_time]
          ]
        } else if (name == '水池') {
          this.popupObject = [
            ['特征点附属物名称', feature_point],
            ['物探点号', geophysical_point_number],
            ['编号', pipe_network_number],
            ['坐标X', coordinate_point_x],
            ['坐标Y', coordinate_point_y],
            ['地面高程m', ground_elevation],
            ['安装时间', install_time]
          ]
          this.costname = object.feature_point
          this.newpopupObject1 = [
            ['特征点附属物名称', feature_point],
            ['物探点号', geophysical_point_number],
            ['编号', pipe_network_number],
            ['坐标X', coordinate_point_x],
            ['坐标Y', coordinate_point_y],
            ['地面高程m', ground_elevation],
            ['安装时间', install_time]
          ]
        } else if (name == '消防栓') {
          this.popupObject = [
            ['特征点附属物名称', feature_point],
            ['物探点号', geophysical_point_number],
            ['编号', pipe_network_number],
            ['口径', 'DN' + pipe_diameter_size],
            ['状态', statusName],
            ['所属道路', subordinate_way],
            ['坐标X', coordinate_point_x],
            ['坐标Y', coordinate_point_y],
            ['地面高程m', ground_elevation],
            ['安装时间', install_time]
          ]
          this.costname = object.feature_point
          this.newpopupObject1 = [
            ['特征点附属物名称', feature_point],
            ['物探点号', geophysical_point_number],
            ['编号', pipe_network_number],
            ['口径', 'DN' + pipe_diameter_size],
            ['状态', statusName],
            ['所属道路', subordinate_way],
            ['坐标X', coordinate_point_x],
            ['坐标Y', coordinate_point_y],
            ['地面高程m', ground_elevation],
            ['安装时间', install_time]
          ]
        } else {
          this.popupObject = [
            ['特征点附属物名称', feature_point],
            ['物探点号', geophysical_point_number],
            // ['连接点号', connection_point_number],
            ['管材', pipeline_material],
            ['管径', 'DN' + pipe_diameter_size],
            ['地下埋深', buried_depth + 'm'],
            ['地面高程m', ground_elevation],
            ['坐标X', coordinate_point_x],
            ['坐标Y', coordinate_point_y],
            ['安装时间', install_time]
          ]
          this.costname = object.feature_point
          this.newpopupObject1 = [['物探点号', geophysical_point_number]]
          this.newpopupObject2 = [
            ['特征点附属物名称', feature_point],
            ['管材', pipeline_material],
            ['管径', 'DN' + pipe_diameter_size],
            ['地下埋深', buried_depth + 'm'],
            ['地面高程m', ground_elevation],
            ['坐标X', coordinate_point_x],
            ['坐标Y', coordinate_point_y],
            ['安装时间', install_time]
          ]
        }
      } else if (id === 'gis_pipe_line' || id === 'search_gis_pipe_line') {
        const {
          start_class_no,
          end_class_no,
          start_geophysical_point_number,
          end_geophysical_point_number,
          pipe_material,
          pipe_diameter,
          buried_depth,
          completion_date
        } = object
        // object.geo_json  coordinates
        var distance = 0
        if (JSON.parse(object.geo_json).type === 'LineString') {
          var points = JSON.parse(object.geo_json).coordinates
          var from = turf.point(points[0])
          var to = turf.point(points[1])
          var options = { units: 'kilometers' }
          distance = turf.distance(from, to, options) * 1000
          distance = distance.toFixed(2)
          var feature = new Feature({
            geometry: new LineString(points)
          })
          if (this.redSourceLength) {
            this.redSource.getFeatures().forEach((item, index) => {
              if (index > 0) {
                this.redSource.removeFeature(item)
              }
            })
          } else {
            this.redSource.getFeatures().forEach((item, index) => {
              this.redSource.removeFeature(item)
            })
          }
          this.redSource.addFeature(feature)
        }
        // alert(points)
        this.popupObject = [
          ['起点分类编码', start_class_no],
          ['终点分类编码', end_class_no],
          // ['起点物探点', start_geophysical_point_number],
          // ['终点物探点', end_geophysical_point_number],
          ['管材', pipe_material],
          ['管径', 'DN' + pipe_diameter],
          ['埋深', buried_depth + 'm'],
          ['长度', distance + 'm'],
          ['竣工时间', completion_date]
        ]
        this.costname = '管段'
        this.newpopupObject1 = [
          ['起点分类编码', start_class_no],
          ['终点分类编码', end_class_no]
        ]
        this.newpopupObject2 = [
          ['管材', pipe_material],
          ['管径', 'DN' + pipe_diameter],
          ['埋深', buried_depth + 'm'],
          ['长度', distance + 'm'],
          ['竣工时间', completion_date]
        ]
      } else if (id == 'gis_pipe_network') {
        console.log(id)
        const {
          class_no,
          geophysical_point_number,
          feature_point,
          appendage,
          structure,
          point_x,
          point_y,
          texture_material,
          caliber,
          buried_depth,
          valve_type,
          brand,
          status,
          elevation,
          completion_date,
          water_count,
          forcing_pump_status,
          unit_num, // 机组数量
          unit_power
        } = object
        // eslint-disable-next-line camelcase
        const name = feature_point || appendage || structure
        console.log(name)
        this.popupObject = [
          ['分类编码', class_no],
          ['物探点', geophysical_point_number],
          ['特征点', feature_point],
          ['附属物', appendage],
          ['构造物', structure],
          ['坐标X', point_x],
          ['坐标Y', point_y],
          ['材质', texture_material],
          ['口径', caliber],
          ['埋深', buried_depth + 'm'],
          ['地面高程', elevation],
          ['竣工时间', completion_date],
          ['水表数量', water_count]
        ]
        this.costname = name
        this.newpopupObject1 = [['分类编码', class_no]]
        this.newpopupObject2 = [
          ['物探点', geophysical_point_number],
          ['特征点', feature_point],
          ['附属物', appendage],
          ['构造物', structure],
          ['坐标X', point_x],
          ['坐标Y', point_y],
          ['材质', texture_material],
          ['口径', caliber],
          ['埋深', buried_depth + 'm'],
          ['地面高程', elevation],
          ['竣工时间', completion_date],
          ['水表数量', water_count]
        ]
        if (name == '阀门') {
          this.popupObject = [
            ['名称', name],
            ['分类编码', class_no],
            ['阀门类型', valve_type],
            ['口径', caliber],
            ['品牌', brand],
            ['状态', status],
            ['坐标X', point_x],
            ['坐标Y', point_y],
            ['地面高程', elevation],
            ['竣工时间', completion_date]
          ]
          this.costname = name
          this.newpopupObject1 = [['分类编码', class_no]]
          this.newpopupObject2 = [
            ['阀门类型', valve_type],
            ['口径', caliber],
            ['品牌', brand],
            ['状态', status],
            ['坐标X', point_x],
            ['坐标Y', point_y],
            ['地面高程', elevation],
            ['竣工时间', completion_date]
          ]
        } else if (appendage == '水表') {
          this.popupObject = [
            ['名称', name],
            ['分类编码', class_no],
            ['坐标X', point_x],
            ['坐标Y', point_y],
            ['地面高程', elevation],
            ['水表数量', water_count],
            ['竣工时间', completion_date]
          ]
          this.costname = name
          this.newpopupObject1 = [['分类编码', class_no]]
          this.newpopupObject2 = [
            ['坐标X', point_x],
            ['坐标Y', point_y],
            ['地面高程', elevation],
            ['水表数量', water_count],
            ['竣工时间', completion_date]
          ]
        } else if (name == '水表井') {
          this.popupObject = [
            ['名称', name],
            ['分类编码', class_no],
            ['材质', texture_material],
            ['坐标X', point_x],
            ['坐标Y', point_y],
            ['地面高程', elevation],
            ['竣工时间', completion_date]
          ]
          this.costname = name
          this.newpopupObject1 = [['分类编码', class_no]]
          this.newpopupObject2 = [
            ['材质', texture_material],
            ['坐标X', point_x],
            ['坐标Y', point_y],
            ['地面高程', elevation],
            ['竣工时间', completion_date]
          ]
        } else if (name == '消防栓') {
          this.popupObject = [
            ['名称', name],
            ['分类编码', class_no],
            ['口径', caliber],
            ['状态', status],
            ['坐标X', point_x],
            ['坐标Y', point_y],
            ['地面高程', elevation],
            ['竣工时间', completion_date]
          ]
          this.costname = name
          this.newpopupObject1 = [['分类编码', class_no]]
          this.newpopupObject2 = [
            ['口径', caliber],
            ['状态', status],
            ['坐标X', point_x],
            ['坐标Y', point_y],
            ['地面高程', elevation],
            ['竣工时间', completion_date]
          ]
        } else if (name == '排水阀') {
          this.popupObject = [
            ['名称', name],
            ['分类编码', class_no],
            ['阀门类型', valve_type],
            ['状态', status],
            ['口径', caliber],
            ['品牌', brand],
            ['坐标X', point_x],
            ['坐标Y', point_y],
            ['地面高程', elevation],
            ['竣工时间', completion_date]
          ]
          this.costname = name
          this.newpopupObject1 = [['分类编码', class_no]]
          this.newpopupObject2 = [
            ['阀门类型', valve_type],
            ['状态', status],
            ['口径', caliber],
            ['品牌', brand],
            ['坐标X', point_x],
            ['坐标Y', point_y],
            ['地面高程', elevation],
            ['竣工时间', completion_date]
          ]
        } else if (appendage == '加压泵站') {
          this.popupObject = [
            ['名称', name],
            ['分类编码', class_no],
            ['机组数量', unit_num],
            ['机组功率', unit_power],
            ['加压泵类型', forcing_pump_status],
            ['品牌', brand],
            ['坐标X', point_x],
            ['坐标Y', point_y],
            ['地面高程', elevation],
            ['竣工时间', completion_date]
          ]
          this.costname = name
          this.newpopupObject1 = [['分类编码', class_no]]
          this.newpopupObject2 = [
            ['机组数量', unit_num],
            ['机组功率', unit_power],
            ['加压泵类型', forcing_pump_status],
            ['品牌', brand],
            ['坐标X', point_x],
            ['坐标Y', point_y],
            ['地面高程', elevation],
            ['竣工时间', completion_date]
          ]
        } else if (name == '排气阀') {
          this.popupObject = [
            ['名称', name],
            ['分类编码', class_no],
            ['阀门类型', valve_type],
            ['状态', status],
            ['口径', caliber],
            ['品牌', brand],
            ['坐标X', point_x],
            ['坐标Y', point_y],
            ['地面高程', elevation],
            ['竣工时间', completion_date]
          ]
          this.costname = name
          this.newpopupObject1 = [['分类编码', class_no]]
          this.newpopupObject2 = [
            ['阀门类型', valve_type],
            ['状态', status],
            ['口径', caliber],
            ['品牌', brand],
            ['坐标X', point_x],
            ['坐标Y', point_y],
            ['地面高程', elevation],
            ['竣工时间', completion_date]
          ]
        } else if (name == '阀门井') {
          this.popupObject = [
            ['名称', name],
            ['分类编码', class_no],
            ['材质', texture_material],
            ['坐标X', point_x],
            ['坐标Y', point_y],
            ['地面高程', elevation],
            ['竣工时间', completion_date]
          ]
          this.costname = name
          this.newpopupObject1 = [['分类编码', class_no]]
          this.newpopupObject2 = [
            ['材质', texture_material],
            ['坐标X', point_x],
            ['坐标Y', point_y],
            ['地面高程', elevation],
            ['竣工时间', completion_date]
          ]
        } else if (name == '水井表') {
          this.popupObject = [
            ['名称', name],
            ['分类编码', class_no],
            ['材质', texture_material],
            ['坐标X', point_x],
            ['坐标Y', point_y],
            ['地面高程', elevation],
            ['竣工时间', completion_date]
          ]
          this.costname = name
          this.newpopupObject1 = [['分类编码', class_no]]
          this.newpopupObject2 = [
            ['材质', texture_material],
            ['坐标X', point_x],
            ['坐标Y', point_y],
            ['地面高程', elevation],
            ['竣工时间', completion_date]
          ]
        } else if (name == '预留口') {
          this.popupObject = [
            ['名称', name],
            ['分类编码', class_no],
            ['口径', caliber],
            ['坐标X', point_x],
            ['坐标Y', point_y],
            ['地面高程', elevation],
            ['竣工时间', completion_date]
          ]
          this.costname = name
          this.newpopupObject1 = [['分类编码', class_no]]
          this.newpopupObject2 = [
            ['口径', caliber],
            ['坐标X', point_x],
            ['坐标Y', point_y],
            ['地面高程', elevation],
            ['竣工时间', completion_date]
          ]
        } else if (name == '弯头' || name == '一般管线点' || name == '变径' || name == '四通') {
          this.popupObject = [
            ['名称', name],
            ['分类编码', class_no],
            ['材质', texture_material],
            ['口径', caliber],
            ['坐标X', point_x],
            ['坐标Y', point_y],
            ['地面高程', elevation],
            ['竣工时间', completion_date]
          ]
          this.costname = name
          this.newpopupObject1 = [['分类编码', class_no]]
          this.newpopupObject2 = [
            ['材质', texture_material],
            ['口径', caliber],
            ['坐标X', point_x],
            ['坐标Y', point_y],
            ['地面高程', elevation],
            ['竣工时间', completion_date]
          ]
        } else if (name == '分区流量计' || name == '变材') {
          this.popupObject = [
            ['名称', name],
            ['分类编码', class_no],
            ['坐标X', point_x],
            ['坐标Y', point_y],
            ['地面高程m', elevation],
            ['竣工时间', completion_date]
          ]
          this.costname = name
          this.newpopupObject1 = [['分类编码', class_no]]
          this.newpopupObject2 = [
            ['坐标X', point_x],
            ['坐标Y', point_y],
            ['地面高程m', elevation],
            ['竣工时间', completion_date]
          ]
        } else if (name == '三通') {
          this.popupObject = [
            ['名称', name],
            ['分类编码', class_no],
            ['材质', texture_material],
            ['口径', caliber],
            ['坐标X', point_x],
            ['坐标Y', point_y],
            ['地面高程', elevation],
            ['竣工时间', completion_date]
          ]
          this.costname = name
          this.newpopupObject1 = [['分类编码', class_no]]
          this.newpopupObject2 = [
            ['材质', texture_material],
            ['口径', caliber],
            ['坐标X', point_x],
            ['坐标Y', point_y],
            ['地面高程', elevation],
            ['竣工时间', completion_date]
          ]
        }
      } else {
        const { geophysical_point_number, connection, pipeline_material, pipe_diameter_size, buried_depth } = object
        // object.geo_json  coordinates
        var distance = 0
        if (JSON.parse(object.geo_json).type === 'LineString') {
          var points = JSON.parse(object.geo_json).coordinates
          var from = turf.point(points[0])
          var to = turf.point(points[1])
          var options = { units: 'kilometers' }
          distance = turf.distance(from, to, options) * 1000
          distance = distance.toFixed(2)
        }
        // alert(points)
        this.popupObject = [
          ['物探起点点号', geophysical_point_number],
          ['物探终点点号', connection],
          ['管材', pipeline_material],
          ['管径', 'DN' + pipe_diameter_size],
          ['长度', distance + 'm'],
          ['埋深', buried_depth + 'm']
        ]
        this.costname = name
        this.newpopupObject1 = [
          ['物探起点点号', geophysical_point_number],
          ['物探终点点号', connection],
          ['管材', pipeline_material],
          ['管径', 'DN' + pipe_diameter_size],
          ['长度', distance + 'm'],
          ['埋深', buried_depth + 'm']
        ]
      }
    },

    /* 图例抽屉方法 */
    afterVisibleChange (val) {
      console.log('visible', val)
    },

    closedrawer () {
      this.showLengend = false
    },
    /**
     * 点击复制方法
     */
    copyUrl (val) {
      // 模拟 输入框
      var cInput = document.createElement('input')
      cInput.value = val

      document.body.appendChild(cInput)
      cInput.select() // 选取文本框内容

      // 执行浏览器复制命令
      // 复制命令会将当前选中的内容复制到剪切板中（这里就是创建的input标签）
      // Input要在正常的编辑状态下原生复制方法才会生效

      document.execCommand('copy', false)

      this.$message.info('复制成功')
      // 复制成功后再将构造的标签 移除
      document.body.removeChild(cInput)
    }
  }
}
</script>

<style lang="less" scoped>
// #scalebar
//         {
//             float:left;
//             margin-bottom:100px;
//             z-index:20000;
//         }
/deep/ .ol-scale-line.ol-unselectable {
  z-index: 9999;
}

.map_container {
  width: 100%;
  height: 100%;
  position: relative;

  .right-btn {
    background: rgba(0, 32, 54, 0.6);
    box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    width: 12vw;
    height: 30vh;
    position: absolute;
    right: 0;
    top: 4%;
    z-index: 5;
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;

    .right-item {
      text-align: center;
      height: 50px;
      width: 100%;
      margin-top: 6%;

      img {
        margin-top: 25%;
        height: 24px;
        width: 24px;
      }
    }

    .right-item:hover {
      background: rgba(0, 32, 54, 1);
      cursor: pointer;
    }
  }

  .map {
    width: 100%;
    height: 100%;
    position: relative;

    .radius {
      float: left;
      width: 4px;
      height: 21px;
      background: #0265ff;
      border-radius: 3px;
    }

    .radiusTitle {
      margin-left: 10px;
      font-family: MicrosoftYaHeiSemibold;
      font-size: 16px;
      color: #404549;
      font-weight: 600;
    }

    .search-btn {
      height: 40px;
      width: 40px;
      position: absolute;
      z-index: 900;
      top: calc(16rem - 75px);
      background-image: linear-gradient(270deg, #e2e2e2 0%, #ffffff 100%);
      background: #f0f2f5 url(~@/assets/myImg/1/ns-icon-querynull.png) no-repeat center;
      // background-position: 40% 10%;
      background-size: 16px 16px;
      border: 1px solid #ffffff;
      box-shadow: 6px 0 6px 0 rgba(0, 0, 0, 0.15);
      border-radius: 0 6px 6px 0;
      line-height: 65px;
      padding-left: 4px;
      color: black;
    }

    .search-btn:hover {
      background: #f0f2f5 url(~@/assets/myImg/1/ns-icon-query-lightnull.png) no-repeat center;
      background-size: 16px 16px;
      cursor: pointer;
      color: rgb(11, 145, 242);
    }

    .tube-btn {
      height: 40px;
      width: 40px;

      background-image: linear-gradient(270deg, #e2e2e2 0%, #ffffff 100%);
      background: #f0f2f5 url(~@/assets/myImg/1/ns-icon-burst.png) no-repeat center;
      // background-position: 40% 10%;
      background-size: 18px 18px;
    }

    //   .active-class {
    //     height: 36px;
    //     width: 36px;
    //     position: absolute;
    //       left:16rem;
    //     z-index: 5;
    //     top: calc(20rem - 75px);
    //     background-image: linear-gradient(270deg, #E2E2E2 0%, #FFFFFF 100%);
    // border: 1px solid #FFFFFF;
    // box-shadow: 6px 0 6px 0 rgba(0,0,0,0.15);
    //   }
  }

  .content-info {
    position: absolute;
    background: #fff;
    box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.1);
    border-radius: 6px;
    bottom: 1vh;
    right: 5vw;
    z-index: 5;
    width: 90vw;

    .info-title {
      background-color: #fff;
      border-radius: 6px 6px 0 0;
      display: flex;
      height: 36px;
      align-items: center;
      color: #ffffff;
      margin-bottom: 9px;

      .info-title--content {
        width: 100%;
        flex: 1;
        font-family: MicrosoftYaHeiSemibold;
        font-size: 18px;
        color: rgb(0, 0, 0);
        font-weight: 600;
        line-height: 12px;
        height: 12px;
        margin-left: 2%;
      }

      .info-title--sufix {
        width: 12px;
        height: 12px;
        margin-right: 12px;
      }
    }
  }
}

.ol-popup {
  position: absolute;
  background: rgba(0, 32, 54, 0.75);
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  border: 1px solid #cccccc;
  bottom: 12px;
  left: -50px;
  width: 240px;

  .popup_title {
    display: flex;
    height: 36px;
    align-items: center;
    background-image: linear-gradient(270deg, rgba(8, 144, 242, 0.5) 0%, #0890f2 100%);
    border-radius: 6px 6px 0 0;
    margin-bottom: 9px;

    .popup_title--prefix {
      width: 4px;
      height: 12px;
      background-color: #0890f2;
      margin-right: 5px;
      margin-left: 12px;
    }

    .popup_title--content {
      font-family: MicrosoftYaHei;
      font-size: 13px;
      color: #ffffff;
      font-weight: 400;
      width: 100%;
      flex: 1;
      line-height: 12px;
      height: 12px;
    }

    .popup_title--sufix {
      width: 12px;
      height: 12px;
      margin-right: 12px;
    }
  }
}

.ol-popup:after,
.ol-popup:before {
  top: 100%;
  border: solid transparent;
  content: ' ';
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}

.ol-popup:after {
  border-top-color: white;
  border-width: 10px;
  left: 48px;
  margin-left: -10px;
}

.ol-popup:before {
  border-top-color: #cccccc;
  border-width: 11px;
  left: 48px;
  margin-left: -11px;
}

.ol-popup-closer {
  text-decoration: none;
  position: absolute;
  top: 2px;
  right: 8px;
}

.ol-popup-closer:after {
  content: '✖';
}

.lengend {
  position: absolute;
  background: rgb(236, 237, 241);
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  top: 7%;
  left: 0;
  z-index: 5;
  width: 100%;
  height: 90vh;

  .layers {
    width: 100%;
    max-height: 100vh;
    overflow-y: scroll;
    overflow-x: hidden;
    padding: 2%;

    &::-webkit-scrollbar {
      width: 3px;
      height: 1px;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 3px;
      background: rgba(12, 23, 34, 0.75);
    }

    &::-webkit-scrollbar-track {
      box-shadow: inset 0 0 1px rgba(0, 0, 0, 0);
      border-radius: 3px;
      background: rgba(32, 23, 44, 0.75);
    }

    .layer {
      color: #000;
      font-size: 10px;
      width: 95%;

      height: 32px;
      background: rgba(255, 255, 255, 1);
      border-radius: 3px;
      margin: 0 auto 5px;
      display: flex;
      align-items: center;

      .layer-prefix {
        height: 22px;

        .prefix_icon {
          height: 100%;
          width: 20px;
          margin-left: 5px;
          margin-right: 5px;
        }
      }

      .layer-content {
        width: 100%;
        flex: 1;
      }

      .layer-sufix {
        margin-left: 12px;
        margin-right: 12px;
        height: 12px;
        width: 12px;
      }
    }
  }

  .lengend_title {
    background-image: linear-gradient(270deg, rgba(8, 144, 242, 0.5) 0%, #0890f2 100%);
    border-radius: 6px 6px 0 0;
    display: flex;
    height: 36px;
    align-items: center;
    color: #ffffff;
    margin-bottom: 9px;

    .legend_title--prefix {
      width: 4px;
      height: 12px;
      background-color: #0890f2;
      margin-right: 5px;
      margin-left: 12px;
    }

    .legend_title--content {
      width: 100%;
      flex: 1;
      font-family: MicrosoftYaHeiSemibold;
      font-size: 12px;
      color: #ffffff;
      font-weight: 600;
      line-height: 12px;
      height: 12px;
    }

    .legend_title--sufix {
      width: 12px;
      height: 12px;
      margin-right: 12px;
    }
  }
}

/deep/ .ant-divider-horizontal {
  margin: 0 !important;
}
</style>
